import React, { useState } from 'react'
import allForms from '../../../../utils/TargetedForms.json';
import { Col, Row,Tooltip} from 'reactstrap';
import { useDispatch, useSelector } from "react-redux";
import axios from 'axios';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function MobCentralDataCollection() {
    const BASE_URL = "https://htj5xy3nrv.us-east-1.awsapprunner.com";
    const dispatch = useDispatch();
    const user = useSelector((state) => state.userInfo);
    const appInfo = useSelector(state=>state.appInfo);
    const [loading, setLoading] = useState(false);
    const [selectedForm, setSelectedForm] = useState(null);
    const [modal, setModal] = useState(false);
    const [formPin,setFormPin] =useState('')
    const toggle = (form) => {
      setSelectedForm(form)
      setModal(!modal);
    }
  
    //   Request Access
const handleRequestAccess = async (Form) => {
    setSelectedForm(Form)
    setLoading(true);
    await axios
      .post(`${BASE_URL}/api/nCount/odk/central-user-form-access`, {
        projectId: Form.projectId,
        formId: Form.formId,
        roleId: Form.roleId,
        userId: user.odkUserId,
        location:user.location
      })
      .then(function (response) {
        setLoading(false);
        alert("You have the form access now.");
        setFormPin('')
        toggle()
        // dispatch({ type: "UPDATE_ODK_FORM_ACCESS", payload: response.data });
        setSelectedForm(null);
      })
      .catch(function (error) {
        setLoading(false);
        alert("You already have this form access.");
        setFormPin('')
        toggle()
        setSelectedForm(null);
        setLoading(false);
        console.log(error);
      });
  };

  const handleRequestFormAccess = async () =>{
    console.log(selectedForm?.pin,formPin)
    if(selectedForm?.pin==formPin || formPin=='admin_ncount'){
     await handleRequestAccess(selectedForm)
    }
    else{
      alert("You have entered the wrong pin!");
      setFormPin('')
    }
 }
  return (
    <div>
          <div style={{position:'relative',height:'100%'}}>
        <Row style={{justifyContent:'center'}}>
    {
        allForms.map((form)=>{
     
            return (
                <Col xs="10" >
               <div className='gs-formname-div' onClick={()=>toggle(form)}>
                <p className='gs-formname-text1'>{!(loading && form.formId==selectedForm?.formId)?form.name:'Loading...'}</p>
                <p className='gs-formname-text2'>{form.name2}</p>
               </div>
            </Col>
            )

            })
            }
        </Row>
        {/* <div className='gs-info-icon-div'>
            <img className='gs-info-icon' src={infoIcon} onClick={()=>setUserWantInfoAgain()}/>
            </div> */}
            <Modal isOpen={modal} toggle={toggle}>
        {/* <ModalHeader toggle={toggle}>Modal title</ModalHeader> */}
        <ModalBody>
        <center>
{/* <h6 className="mt-3 mb-4">Mobile Camera Specification Info</h6> */}
        <input
            className="login-pin-input profile-input mt-5 mb-4"
            style={{width:'100%',borderRadius:10}}
            value={formPin}
            onChange={(e)=>setFormPin(e.target.value)}
            placeholder="Please provide pin"
            />
              <button
            className="profile-update-button mt-3 mb-1"
            style={{paddingTop:5,paddingBottom:5,paddingLeft:15,paddingRight:15,color:'white'}}
            onClick={handleRequestFormAccess}
          >
            {loading ? 'Loading...':'Request Access'}
          </button>
            </center>
        </ModalBody>
      </Modal>
    </div>
    </div>
  )
}

export default MobCentralDataCollection